import { useRef, useState } from 'react';
import { IVec2 } from '../utils/vec2';
import { IAudioClip, IAudioTrack } from '../models/Timeline';
import { ITrackId } from '../models/Selection';
import { ILoadedAudioFile } from '../models/LoadedAudioFiles';

export enum DragType {
	TimelineBar,
	AudioClip,
}

interface TimelineBarDragInfo {
	type: DragType.TimelineBar;
}

interface AudioClipDragInfo {
	type: DragType.AudioClip;
	audioClip: IAudioClip | ILoadedAudioFile;
	audioTrack: ITrackId | null;
	pos: IVec2; // Position of top left corner of clip inside the trackContentContainer
	pointerOffset: IVec2; // Offset from top left corner of clip to pointer pos
}

type DragInfo = AudioClipDragInfo | TimelineBarDragInfo;

const useAudioDrag = () => {
	const [drag, setDrag] = useState<DragInfo | null>(null);

	const trackContentContainerRef = useRef<HTMLDivElement>(null);
	const audioTrackPositions = useRef<{ trackId: ITrackId; yMin: number; yMax: number }[]>([]);

	return {
		drag,
		setDrag,
		trackContentContainerRef,
		audioTrackPositions,
	};
};

export default useAudioDrag;
